import { checkoutUrl } from '~/lib/routing'
import { url } from '~/lib/url'

export function useLogoLink() {
  const route = useRoute()
  const { $currentStorefront } = useNuxtApp()

  const isAddressOrPaymentStep = computed(() =>
    route.meta.view === 'address' || route.meta.view === 'payment',
  )

  const logoUrl = computed(() => {
    if (isAddressOrPaymentStep.value) {
      return checkoutUrl({
        route,
        view: 'cart',
        storefrontCode: $currentStorefront.storefrontCode
      })
    }
    return url('/')
  })

  const logoAriaLabel = computed(() => {
    if (isAddressOrPaymentStep.value) {
      // Use existing translation key for "Cart"
      return 'cart'
    }
    // Use existing translation key for "Home"
    return 'home'
  })

  return {
    isAddressOrPaymentStep,
    logoUrl,
    logoAriaLabel,
  }
}
